import Aos from "aos";
import React from "react";
import "./description.scss";

function Description({ image, heading, content,mainText }) {
  Aos.init({
    delay: 500,
    once: true,
  });
  return (
    <div className="description">
      <div className="description">
      <h1 data-aos="fade-up-right">{heading}</h1>
	  		<div className="sec3">
              <h5 data-aos="zoom-out">{mainText.heading}</h5>
              <p data-aos="zoom-out">{mainText.paragraph}</p>
            </div>
			<div className="sec4">
				<div className="sec2">
				{content.map((des) => (
					<div>
					<h5 data-aos="zoom-out">{des.heading}</h5>
					<p data-aos="zoom-out">{des.paragraph}</p>
					</div>
				))}
				</div>
				<div className="sec1">
				<img
					alt="coursesImage"
					src={image}
					className="fullImg fullimg1"
					data-aos="fade-up-left"
				/>
        		</div>
			</div>
      </div>
    </div>
  );
}

export default Description;
